const Fields = [
    {
        name: "name",
        label: "Name",
        visible: true,
        editable: true,
        type: "text",
        validation: [
                { type: "required"},
                {type: "regex", pattern:"^[a-z0-9-]*$",
                errMsg:"name only supports lowercase letters, numbers and dashes."}
            ],
            helpText: `<p><a href="https://help.aqfer.net/lakeview-api/job-naming-convention?from_search=129606375" target="_blank">Click here to view Naming Convention rules</a></p>`
    },
    {
        key: true,
        name: "cid",
        label: "Cid",
        type: "select",
        editable: true,           
        validation: [
            { type: "required"},
        ]
    },
    {
        name: "sandbox",
        label: "Sandbox",
        visible: true,
        editable: true,
        type: "select",
        validation: [
            { type: "required"},
        ]
    }
];

export default Fields;